import { connect } from 'react-redux'
import { showAlert, showAlertWithCallback } from '../utils/Alert'
import {
  fetchLines,
  fetchTrains,
  fetchSingleTrain,
  receiveLines,
  receiveTrainPosition,
  receiveSingleTrain,
  closeTrainModal,
} from '../actions'
import SingleTrainModal from '../components/train_positions/SingleTrainModal'

const mapStateToProps = state => {
  const { lines, trains, nankai_update_date, nankai_update_time, koya_update_date, koya_update_time, nankai_scheduleTypes, koya_scheduleTypes, train_kind_name, departure_station_name, arrival_station_name, station_infos } = state.trainPositionReducer
  const { themeName } = state.themeReducer
  
  return {
    lines,
    trains,
    nankai_update_date,
    nankai_update_time,
    koya_update_date,
    koya_update_time,
    nankai_scheduleTypes,
    koya_scheduleTypes,
    train_kind_name, 
    departure_station_name, 
    arrival_station_name, 
    station_infos,
    themeName,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchLines: async () => {
      try {
        const payload = await fetchLines()
        dispatch(receiveLines(payload))
      } catch (error) {
        showAlert('路線が取得できませんでした')
      }
    },
    fetchTrains: async (lines_url) => {
      try {
        const payload = await fetchTrains()
        dispatch(receiveTrainPosition(payload))
      } catch (error) {
        showAlertWithCallback('在線情報が取得できませんでした', function() {
          // 列車走行位置に戻る
          window.location.href = lines_url
        })
      }
    },
    fetchSingleTrain: async (line_id, scheduleTypes, baseTime, train_number) => {
      try {
        const payload = await fetchSingleTrain(line_id, scheduleTypes, baseTime, train_number)
        dispatch(receiveSingleTrain(payload))
      } catch (error) {
        showAlert('列車情報が取得できませんでした')
      }
    },
    closeTrainModal: () => {
      dispatch(closeTrainModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleTrainModal)
